import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SmashThemeModule } from '@app/shared/modules/smash-theme/smash-theme.module';
import { SharedModule } from '@app/shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { LayoutModule } from './layout/layout.module';
import * as fromUploader from '@app/client/uploader/store/reducers';
import { UploaderComponent } from './uploader.component';
import { UPLOADER_ROUTES } from './uploader.routes';
import { EffectsModule } from '@ngrx/effects';
import { SubscriptionEffects } from '@app/client/signup/subscription/effects/subscription.effects';
import * as fromSignup from '@app/client/signup/reducers';
import { AccountEffects, PaymentEffects, DomainEffects } from '@app/core/effects';
import { UploadEffects, PrepareEffects, SendEffects, DropboxEffects } from '@app/client/uploader/store/effects';
import { SmashCguCookiesModule } from '@app/shared/modules/smash-cgu-cookies/smash-cgu-cookies';

@NgModule({
  declarations: [
    UploaderComponent,
  ],
  imports: [
    CommonModule,
    LayoutModule,
    SharedModule,
    StoreModule.forFeature(fromUploader.uploaderFeatureKey, fromUploader.reducers),
    EffectsModule.forFeature([UploadEffects, PrepareEffects, SendEffects, DropboxEffects, SubscriptionEffects, AccountEffects, PaymentEffects, DomainEffects]),
    RouterModule.forChild(UPLOADER_ROUTES),
    SmashThemeModule,
    // Effects needed for modal over 2gb to compute the plan price (SubscriptionEffects, AccountEffects, PaymentEffects, DomainEffects)
    StoreModule.forFeature(fromSignup.signupFeatureKey, fromSignup.reducers),
    SmashCguCookiesModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class UploaderModule {

  constructor() { }

}
